import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// Log which Firebase project this build is talking to (helpful in dev)
if (import.meta.env.DEV) {
  console.info(`[firebase] connected to project: ${firebaseConfig.projectId}`);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Functions deploy to us-west1 (see functions/src/index.ts setGlobalOptions).
export const functions = getFunctions(app, "us-west1");
export const googleProvider = new GoogleAuthProvider();

export default app;
